import { getRouteApi } from "@tanstack/react-router";
import { FilterBadge } from "@/components/FilterBadges";
import { type ContactFilters } from "@/contacts/schemas/contactFilterSchema";

const routePath = "/(authed)/_layout/contacts";
const routeApi = getRouteApi(routePath);

interface FilterBadgesProps {
  filters: ContactFilters;
  onUpdateFilters: (newFilters: ContactFilters) => void;
  handleResetPagination: () => void;
  roleOptions: Array<{ label: string; value: string }>;
  typeOptions: Array<{ label: string; value: string }>;
}

export function FilterBadges({
  filters,
  onUpdateFilters,
  handleResetPagination,
  roleOptions,
  typeOptions,
}: FilterBadgesProps) {
  const navigate = routeApi.useNavigate();

  const handleRemoveRole = (roleToRemove: string) => {
    const updatedRoles = filters.roles?.filter((r) => r !== roleToRemove);

    onUpdateFilters({
      ...filters,
      roles: updatedRoles,
    });

    handleResetPagination();

    void navigate({
      search: (prev) => ({
        ...prev,
        roles: updatedRoles?.length ? updatedRoles : undefined,
      }),
    });
  };

  const handleRemoveType = (typeToRemove: string) => {
    const updatedTypes = filters.types?.filter((t) => t !== typeToRemove);
    onUpdateFilters({
      ...filters,
      types: updatedTypes,
    });

    handleResetPagination();

    void navigate({
      search: (prev) => ({
        ...prev,
        types: updatedTypes?.length ? updatedTypes : undefined,
      }),
    });
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {filters.roles?.map((roleValue) => {
        const roleOption = roleOptions.find((opt) => opt.value === roleValue);
        return roleOption ? (
          <FilterBadge key={roleValue} active label={roleOption.label} onRemove={() => handleRemoveRole(roleValue)} />
        ) : null;
      })}
      {filters.types?.map((typeValue) => {
        const typeOption = typeOptions.find((opt) => opt.value === typeValue);
        return typeOption ? (
          <FilterBadge key={typeValue} active label={typeOption.label} onRemove={() => handleRemoveType(typeValue)} />
        ) : null;
      })}
    </div>
  );
}
